import { Components, Theme } from '@mui/material/styles';
import DefaultPaletteOptions from 'theming/defaultPalette';

export default (palette: DefaultPaletteOptions): Components<Theme>['MuiLink'] => ({
  styleOverrides: {
    root: {
      color: palette.primary?.dark,
      textDecoration: 'none'
    }
  }
});
